export default __webpack_public_path__ + "//i/components/system-notification/images//user-logged-out-img.png";